export const WCA_API_PAGINATION = 25;

// Mirrors `Registration::DEFAULT_GUEST_LIMIT`, the cap that applies when a competition does not
//   restrict guests itself.
export const DEFAULT_GUEST_LIMIT = 99;

// Mirrors `Registration::COMMENT_CHARACTER_LIMIT`.
export const COMMENT_CHARACTER_LIMIT = 240;
